var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category-index',{attrs:{"title":_vm.title,"description":_vm.description,"items":_vm.category.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }